// "use client";
// import { useState } from "react";
import { Link } from "react-router-dom";
import { IMG } from "../../../assets";
import { CONSTANT } from "../../../constant/Constant";
export const navLink = [
  {
    id: 1,
    title: "Home",
    link: "#hero",
  },
  {
    id: 2,
    title: "Event",
    link: "#event",
  },
  {
    id: 3,
    title: "Services",
    link: "#services",
  },
  {
    id: 4,
    title: "Feedback",
    link: "#feedback",
  },
  // {
  //   id: 5,
  //   title: "Blog",
  //   link: "/",
  // },
];

const Hamburger = ({ open, setOpen }) => {
  return (
    <div
      className="flex relative w-8 h-8 flex-col justify-between items-center lg:hidden z-99 "
      onClick={() => {
        setOpen(!open);
      }}
    >
      {/* hamburger button */}
      <span
        className={`h-1 w-full rounded-lg transform transition duration-300 ease-in-out ${
          open ? "rotate-45 translate-y-3.5 bg-white" : "bg-white"
        }`}
      />
      {!open && (
        <span
          className={`h-1 w-full bg-white rounded-lg transition-all duration-300 ease-in-out ${
            open ? "w-[0px] bg-black" : "w-full"
          }`}
        />
      )}
      <span
        className={`h-1 w-full rounded-lg transform transition duration-300 ease-in-out ${
          open ? "-rotate-45 -translate-y-3.5 bg-white" : "bg-white"
        }`}
      />
    </div>
  );
};
function MobileNav({ open, setOpen, image }) {
  return (
    <div
      className={`absolute top-0 left-0 h-screen w-screen bg-white transform ${
        open ? "translate-x-0" : "-translate-x-full"
      } transition-transform duration-300 ease-in-out filter drop-shadow-md z-10`}
    >
      <div className="relative h-full">
        <div className="h-full w-full absolute bg-black top-0 z-9 opacity-20" />
        <div className="h-full w-full absolute">
          <img
            className="object-cover h-[100%] w-full z-0"
            // src={IMG.banner}
            src={`${CONSTANT.UI_URL}image/${image}`}
            alt=""
          />
        </div>
        <div className="flex items-center justify-between filter drop-shadow-md relative z-10 h-50 px-10 ">
          <Link to="/">
            <img src={IMG.logo} alt="logiIMg" className=" w-[250px]" />
          </Link>
          <Hamburger open={open} setOpen={setOpen} />
        </div>

        <div className="flex flex-col ml-4 mt-5 z-99 filter drop-shadow-md relative z-10">
          {navLink.map((data) => (
            <button
              key={data.id}
              // to={data.link}
              className="text-xl font-medium my-4 text-center text-white"
              // onClick={() =>
              //   setTimeout(() => {
              //     setOpen(!open);
              //   }, 100)
              // }
              onClick={() => {
                setOpen(false); // close mobile menu
                setTimeout(() => {
                  const session = document.querySelector(data.link);
                  if (session) {
                    session.scrollIntoView({ behavior: "smooth" });
                  }
                }, 100); // slight delay so menu closes first
              }}
            >
              {data.title}
            </button>
          ))}
          <div className="flex justify-center">
            <button
              onClick={() => {
                setOpen(false); // close mobile menu
                setTimeout(() => {
                  const session = document.querySelector("#contact");
                  if (session) {
                    session.scrollIntoView({ behavior: "smooth" });
                  }
                }, 100); // slight delay so menu closes first
              }}
              className="text-white bg-event px-8 py-2 rounded-2xl"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Header({ setOpen, open, image }) {
  return (
    <nav className="flex filter py-0 h-50 items-center relative justify-center z-10">
      <div className="w-5/6 max-w-screen-2xl flex items-centerd">
        <MobileNav open={open} setOpen={setOpen} image={image} />
        <div className="w-full lg:w-2/12 flex items-center">
          <Link to="/">
            <img src={IMG.logo} alt="logiIMg" className=" w-[250px]" />
          </Link>
        </div>
        <div className="w-10/12 flex justify-end items-center">
          <Hamburger open={open} setOpen={setOpen} />

          <div className="hidden lg:flex justify-between items-center ">
            <div className="flex justify-start items-center w-auto">
              {/* {navLink.map((data) => (
                <Link key={data.id} href={data.link}>
                  <p className="text-white mr-8">{data.title}</p>
                </Link>
              ))} */}
              {navLink.map((data) => (
                <button
                  key={data.id}
                  onClick={() => {
                    const targetSection = document.querySelector(data.link);
                    if (targetSection) {
                      targetSection.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }}
                >
                  <p className="text-white mr-8">{data.title}</p>
                </button>
              ))}

              <button
                onClick={() => {
                  const session = document.querySelector("#contact");
                  if (session) {
                    session.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="text-white bg-event px-8 py-2 mr-8 rounded-2xl"
              >
                Contact Us
              </button>
            </div>
            <div className="flex  items-center">
              {/* <div className="">
                <Link to="/cart">
                  <img
                    src="/images/cart/cart.png"
                    alt="logiIMg"
                    className="h-[35px] w-[35px]"
                  />
                </Link>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
